import api from "@/lib/api";

export async function getAssetsPresignedUrl({ link, id }) {
  try {
    const { data } = await api.get("/secretaria-digital/assets", { params: { objectName: link, id } })
    return { error: false, url: data.url }
  } catch (error) {
    return { error: true, url: null }
  }
}